import business from "../data/business.json";

// Orari oltre mezzanotte appartengono al giorno di apertura.
// Orario invernale (dal 20 settembre). Indice: 0 = domenica (19:00–02:00),
// 1 = lunedì (chiusa), ... 6 = sabato (20:00–03:00).
const SCHEDULE = [
    { open: 19 * 60, close: 26 * 60 },
    null,
    { open: 21 * 60, close: 26 * 60 },
    { open: 21 * 60, close: 26 * 60 },
    { open: 21 * 60, close: 26 * 60 },
    { open: 20 * 60, close: 27 * 60 },
    { open: 20 * 60, close: 27 * 60 },
];

const DAY_NAMES = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];

export function romeNow() {
    const parts = Object.fromEntries(
        new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/Rome",
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
        })
            .formatToParts(new Date())
            .map((p) => [p.type, p.value])
    );
    const wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[parts.weekday];
    return { wd, minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10) };
}

export function formatMinutes(min) {
    const m = ((min % 1440) + 1440) % 1440;
    return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}

export function getOpenStatus(now = romeNow()) {
    const { wd, minutes } = now;
    const today = SCHEDULE[wd];
    const yesterday = SCHEDULE[(wd + 6) % 7];

    if (today && minutes >= today.open) {
        return { open: true, label: `Aperto ora · chiude alle ${formatMinutes(today.close)}` };
    }
    if (yesterday && minutes < yesterday.close - 1440) {
        return { open: true, label: `Aperto ora · chiude alle ${formatMinutes(yesterday.close)}` };
    }
    if (today && minutes < today.open) {
        return { open: false, label: `Chiuso · apre alle ${formatMinutes(today.open)}` };
    }
    for (let i = 1; i <= 7; i++) {
        const d = (wd + i) % 7;
        if (SCHEDULE[d]) {
            const when = i === 1 ? "domani" : DAY_NAMES[d];
            return { open: false, label: `Chiuso · apre ${when} alle ${formatMinutes(SCHEDULE[d].open)}` };
        }
    }
    return { open: false, label: "Chiuso" };
}

export function todayHoursLabel(now = romeNow()) {
    const row = business.weeklyHours[(now.wd + 6) % 7];
    return row.open
        ? `Oggi ${row.day.toLowerCase()} · ${row.open} – ${row.close}`
        : `Oggi ${row.day.toLowerCase()} · chiuso`;
}

// Indice (0 = lunedì) del giorno corrente a Quarrata, per evidenziare la riga nella tabella orari.
export function currentRomeDayIndex(now = romeNow()) {
    return (now.wd + 6) % 7;
}